import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function SortAscIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M4 14H8.42109C9.35119 14 9.81624 14 9.94012 14.2801C10.064 14.5603 9.74755 14.8963 9.11466 15.5684L5.47691 19.4316C4.84402 20.1037 4.52757 20.4397 4.65145 20.7199C4.77533 21 5.24038 21 6.17048 21H10" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 9L6.10557 4.30527C6.49585 3.43509 6.69098 3 7 3C7.30902 3 7.50415 3.43509 7.89443 4.30527L10 9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.5 20V4M17.5 20C16.7998 20 15.4915 18.0057 15 17.5M17.5 20C18.2002 20 19.5085 18.0057 20 17.5" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
}


